export class SurveyPeriods {
    static surveyPeriodsData: SurveyPeriodsData = {
        "kanagawa": {
            minDays: {
                default: 14,
                sanei: 10,
                nitten: 7,
            },
            maxDate: new Date(2022, 8, 14)
        },
        "nagano": {
            minDays: 7,
            maxDate: new Date(2022, 9, 14)
        },
        "chiba": {
            minDays: 7,
            maxDate: new Date(2022, 9, 14)
        },
        "kyoto": {
            minDays: {
                default: 7,
                cotonet: 10
            },
            maxDate: new Date(2022, 9, 10)
        },
        "osaka": {
            minDays: 7,
            maxDate: new Date(2022, 9, 10)
        },
        "iwate": {
            minDays: 7,
            maxDate: new Date(2021, 8, 15)
        },
        "hokkaido": {
            minDays: 7,
            maxDate: new Date(2022, 8, 14)
        },
        "gunma": {
            minDays: 7,
            maxDate: new Date(2022, 8, 14)
        },
        "kobe": {
            minDays: 7,
            maxDate: new Date(2021, 9, 13)
        },
        "itami": {
            minDays: 7,
            maxDate: new Date(2021, 9, 13)
        },
        "sendai-city": {
            minDays: 7,
            maxDate: new Date(2022, 8, 7)
        },
        "okayama": {
            minDays: 7,
            maxDate: new Date(2022, 8, 14)
        },
        "yamanashi": {
            minDays: 7,
            maxDate: new Date(2022, 8, 14)
        },
        "hyogo": {
            minDays: 7,
            maxDate: new Date(2022, 9, 10)
        },
        "kuwana-city": {
            minDays: 7,
            maxDate: new Date(2022, 8, 28)
        },
        "toyota-city": {
            minDays: 7,
            maxDate: new Date(2022, 8, 28)
        },
    }

    static getMinDaySpan(community: string, supplier?: string): number {
        const minDays = this.surveyPeriodsData[community]?.minDays;
        if (!minDays) {
            return null;
        }

        if (typeof minDays === "number") {
            return minDays
        } else {
            return minDays[supplier] ?? minDays.default;
        }
    }

    static getMaxDateBase(community: string, supplier?: string): Date {
        const maxDate = this.surveyPeriodsData[community]?.maxDate;
        if (!maxDate) {
            return null;
        }

        if (maxDate instanceof Date) {
            return maxDate
        } else {
            return maxDate[supplier] ?? maxDate.default;
        }
    }
}


interface SurveyPeriodsData {
    [community: string]: {
        minDays: number | {
            [supplier: string]: number,
            default: number
        },
        maxDate: Date | {
            [supplier: string]: Date,
            default: Date,
        }
    }
}
